import PageHeader from './page-header.vue'

export { PageHeader }
